// Lib Imports
import React, { useContext } from 'react';
import { CaretRightFill, CaretDownFill } from 'grommet-icons';
import PropTypes from 'prop-types';
import { Box, ThemeContext } from 'grommet';
export const RowExpandCell = ({
  row,
  ...rest
}) => {
  const {
    graniteTable: {
      row: rowThemeProp
    } = {}
  } = useContext(ThemeContext) ?? {};
  const CollapseRow = () => {
    if (rowThemeProp?.CollapsedRowIcon) return /*#__PURE__*/React.createElement(rowThemeProp.CollapsedRowIcon, null);
    return /*#__PURE__*/React.createElement(CaretRightFill, null);
  };
  const ActiveRow = () => {
    if (rowThemeProp?.ExpandedRowIcon) return /*#__PURE__*/React.createElement(rowThemeProp.ExpandedRowIcon, null);
    return /*#__PURE__*/React.createElement(CaretDownFill, null);
  };
  if (row?.original?.disableRowExpandable) return /*#__PURE__*/React.createElement("span", {
    style: {
      cursor: 'not-allowed',
      opacity: '0.5'
    }
  }, rowThemeProp?.DisabledExpandableRowIcon ? /*#__PURE__*/React.createElement(rowThemeProp.DisabledExpandableRowIcon, null) : /*#__PURE__*/React.createElement(CaretRightFill, null));
  return /*#__PURE__*/React.createElement("span", row.getToggleRowExpandedProps(), row.isExpanded ? /*#__PURE__*/React.createElement(ActiveRow, null) : /*#__PURE__*/React.createElement(CollapseRow, null));
};
RowExpandCell.propTypes = {
  row: PropTypes.object
};